import { render } from "./modalFilterSenderPost.vue?vue&type=template&id=c652a0e6&scoped=true&ts=true"
import script from "./modalFilterSenderPost.vue?vue&type=script&lang=ts"
export * from "./modalFilterSenderPost.vue?vue&type=script&lang=ts"

import "./modalFilterSenderPost.vue?vue&type=style&index=0&id=c652a0e6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c652a0e6"]])

export default __exports__